import styles from '../index.scss'

export type IDpBusinessCommodityPrice = {
  detail?: {
    exchangePrice?: string // 价格
    pointPrice?: string // 兑换价格
    redeemUnit?: string // 租户单位
    exchangeType?: number // 支付类型
    exchangePriceSuffix?: boolean // 支付类型
    [key: string]: any
  }
}

  // 1、现金 -- 展示现金 + 单位
  // 2、积分 -- 展示积分 + 单位
  // 3、权益免费使用 -- 不展示
  // 4、第三方权益支付 -- 展示积分 + 单位
  // 5、积分 + 现金 -- 展示积分 + 现金 + 单位
  // 8、现金 + 第三方权益支付 -- 展示现金
const amountPriceMap = (props: IDpBusinessCommodityPrice) => ({
  1: <span>
    {!!props?.detail?.listPrice && <span className={styles['dp-business-commodity--base-listPrice']}>{props?.detail?.listPrice}元</span>}
    {!!props?.detail?.exchangePricePrefixText && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePricePrefixText}&nbsp;</span>}
    {props?.detail?.exchangePrice}
    <span className={styles["dp-business-commodity--priceUnit"]}>元</span>
    {!!props?.detail?.exchangePriceSuffix && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePriceSuffixText || '起'}</span>}
  </span>,
  8: <span>
      {!!props?.detail?.listPrice && <span className={styles['dp-business-commodity--base-listPrice']}>{props?.detail?.listPrice}元</span>}
      {!!props?.detail?.exchangePricePrefixText && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePricePrefixText}&nbsp;</span>}
      {props?.detail?.exchangePrice}
      <span className={styles["dp-business-commodity--priceUnit"]}>元</span>
      {!!props?.detail?.exchangePriceSuffix && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePriceSuffixText || '起'}</span>}
    </span>,
  2: <span>
      {props?.detail?.pointPrice}
      <span className={styles["dp-business-commodity--priceUnit"]}>{props?.detail?.redeemUnit || '积分'}</span>
      {!!props?.detail?.exchangePriceSuffix && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePriceSuffixText || '起'}</span>}
    </span>,
  4: <span>
      {props?.detail?.pointPrice}
      <span className={styles["dp-business-commodity--priceUnit"]}>{props?.detail?.redeemUnit || '积分'}</span>
      {!!props?.detail?.exchangePriceSuffix && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePriceSuffixText || '起'}</span>}
  </span>,
  5: <span>
      {props?.detail?.pointPrice || '0'}
      <span className={styles["dp-business-commodity--priceUnit"]}>{props?.detail?.redeemUnit || '积分'}</span>
       + {props?.detail?.exchangePrice || '0'} 
      <span className={styles["dp-business-commodity--priceUnit"]}>元</span>
      {!!props?.detail?.exchangePriceSuffix && <span className={styles["dp-business-commodity--base-startText"]}>{props?.detail?.exchangePriceSuffixText || '起'}</span>}
    </span>,
})

export default amountPriceMap
